























import { defineComponent, PropType } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { PostFileData } from "@/types";
import PostFileItem from "@/components/PostFileItem";

export default defineComponent({
  name: "PostFileList",
  components: { PostFileItem },
  props: {
    files: { type: Array as PropType<(PostFileData | ContentFile)[]>, required: true },
    underline: { type: Boolean, default: false },
  },
});
